<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  page: {
    title: "Kompetensi Level",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "idverif_kompetensi_level",
      },
      {
        width: "auto",
        label: "Profesi",
        name: "nama_profesi",
      },
      {
        width: "auto",
        label: "Dahan Profesi",
        name: "dahan_profesi",
      },
      {
        width: "auto",
        label: "Kompetensi",
        name: "nama_kompetensi",
      },
      {
        width: "auto",
        label: "Level Proficiency",
        name: "nama_level",
      },
      {
        width: "auto",
        label: "Status",
        name: "active_flag",
      },
      {
        width: "auto",
        label: "Jumlah Soal PG",
        name: "total_soal_pg",
      },
      {
        width: "auto",
        label: "Jumlah Soal BS",
        name: "total_soal_bs",
      },
      {
        width: "auto",
        label: "Jumlah Soal Menjodohkan",
        name: "total_soal_menjodohkan",
      },
      {
        width: "auto",
        label: "Jumlah Soal Essai",
        name: "total_soal_text",
      },
      {
        width: "280px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    // Get hak akses
    const menu = "Kompetensi Level";

    return {
      title: menu,
      items: [
        {
          text: "Verifikasi",
          href: "/",
        },
        {
          text: "Kompetensi Level",
          active: true,
        },
      ],
      isWrite: 1,
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idverif_kompetensi_level", // sort key awal
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        per_page: 10,
        search: "",
        column: "idverif_kompetensi_level",
        dir: "desc",
        filter: {
          active_flag: 1,
        },
      },

      // config untuk paginasi
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
    };
  },
  async mounted() {
    await this.getDataTable();
  },
  methods: {
    getDataTable(
      url = process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-level",
    ) {
      let self = this;
      self.loadingTable = true;

      var config = {
        method: "get",
        url: url,
        params: self.tableFilter,
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          let response_data = response.data;
          let response_data_fix = response_data.data;
          if (response_data.meta.code == 200) {
            self.table_data = response_data_fix.data;
            self.configPagination(response_data_fix);
            self.currentTablePage = response_data_fix.current_page;
            self.loadingTable = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: response_data.meta.message,
            });
          }
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    configPagination(data) {
      let self = this;
      self.pagination.lastPage = data.last_page;
      self.pagination.currentPage = data.current_page;
      self.pagination.total = data.total;
      self.pagination.lastPageUrl = data.last_page_url;
      self.pagination.nextPageUrl = data.next_page_url;
      self.pagination.prevPageUrl = data.prev_page_url;
      self.pagination.from = data.from;
      self.pagination.to = data.to;
      self.pagination.links = data.links;
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },
    toPage(page) {
      let self = this;
      self.tableFilter.page = page;
      self.getDataTable();
    },
    create() {
      this.$router.push({ name: "add-kompetensi-level" });
    },
    edit(data) {
      this.$router.push({
        name: "edit-kompetensi-level",
        params: { id: data.idverif_kompetensi_level },
      });
    },
    changeStatus(data) {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-level/" +
        data.idverif_kompetensi_level +
        "/status";
      let method = "put";

      Swal.fire({
        title: "Apakah anda yakin?",
        text:
          data.active_flag == 1
            ? "Data akan dinonaktifkan!"
            : "Data akan diaktifkan kembali!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                self.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
    deleteData(data) {
      let self = this;
      let url =
        process.env.VUE_APP_BACKEND_URL_VERSION +
        "verifikasi/kompetensi-level/" +
        data.idverif_kompetensi_level;
      let method = "delete";

      Swal.fire({
        title: "Apakah anda yakin?",
        text: "Data akan dihapus secara permanen!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Lanjutkan!",
        cancelButtonText: "Batalkan",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "Sedang memproses data...",
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });

          axios({
            method: method,
            url: url,
            headers: {
              Accept: "application/json",
              Authorization: "Bearer " + localStorage.access_token,
            },
          })
            .then((response) => {
              if (response.data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response.data.meta.message,
                });
                self.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: response.data.meta.message,
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text:
                  error.response?.data?.meta?.message || "Terjadi kesalahan",
              });
            });
        }
      });
    },
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6 text-end">
                <button
                  class="btn btn-success btn-sm"
                  @click="create()"
                  v-if="isWrite == 1"
                >
                  <i class="fa fa-plus me-1"></i> Tambah
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="form-group col-md-3">
                <label for="filterStatus">Status</label>
                <select
                  class="form-control"
                  id="filterStatus"
                  v-model="tableFilter.filter.active_flag"
                  @change="getDataTable()"
                >
                  <option value="1">Aktif</option>
                  <option value="0">Tidak Aktif</option>
                </select>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getDataTable()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
            </div>
            <datatable
              :columns="columns"
              :sortKey="sortKey"
              :sortOrders="sortOrders"
              @sort="sortBy"
            >
              <tbody>
                <tr v-if="loadingTable">
                  <td class="text-center" colspan="99">
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data == ''">
                  <td class="text-center" colspan="99">Data Tidak Tersedia</td>
                </tr>
                <tr
                  v-else
                  v-for="(row_data, key_data) in table_data"
                  :key="key_data"
                >
                  <td>{{ key_data + pagination.from }}</td>
                  <td>{{ row_data.nama_profesi ?? "-" }}</td>
                  <td>{{ row_data.dahan_profesi ?? "-" }}</td>
                  <td>{{ row_data.nama_kompetensi }}</td>
                  <td>{{ row_data.nama_level }}</td>
                  <td>
                    <span
                      class="badge"
                      :class="
                        row_data.active_flag == 1 ? 'bg-success' : 'bg-danger'
                      "
                    >
                      {{ row_data.active_flag == 1 ? "Aktif" : "Tidak Aktif" }}
                    </span>
                  </td>
                  <td>{{ row_data.total_soal_pg }}</td>
                  <td>{{ row_data.total_soal_bs }}</td>
                  <td>{{ row_data.total_soal_menjodohkan }}</td>
                  <td>{{ row_data.total_soal_text }}</td>
                  <td class="text-center">
                    <div class="btn-group">
                      <router-link
                        class="btn btn-primary btn-sm"
                        :to="`/master-verifikasi/kompetensi-level/${row_data.idverif_kompetensi}/soal`"
                      >
                        <i class="fa fa-edit"></i> Setup Soal
                      </router-link>
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        v-if="isWrite == 1 && row_data.active_flag == 1"
                        @click="edit(row_data)"
                      >
                        <i class="fa fa-edit"></i> Edit
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        v-if="isWrite == 1 && row_data.active_flag == 1"
                        @click="changeStatus(row_data)"
                      >
                        <i class="fa fa-trash"></i> Disable
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning btn-sm"
                        v-if="isWrite == 1 && row_data.active_flag == 0"
                        @click="changeStatus(row_data)"
                      >
                        <i class="fa fa-recycle"></i> Enable
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        v-if="isWrite == 1 && row_data.active_flag == 0"
                        @click="deleteData(row_data)"
                      >
                        <i class="fa fa-trash"></i> Hapus
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
            <pagination :pagination="pagination" @to-page="toPage"></pagination>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
